<table mat-table [dataSource]="tableData" class="mat-elevation-z8" *ngIf="tableData && tableData.data.length">

    <!--- Note that these columns can be defined in any order.
          The actual rendered columns are set as a property on the row definition" -->
    <!-- Symbol Column -->
    <ng-container *ngFor="let col of displayedColumns">
        <ng-container [matColumnDef]="col">
            <th mat-header-cell  *matHeaderCellDef> {{normalizeColName(col)}}</th>
            <td mat-cell *matCellDef="let element"> {{element[col]}} </td>
        </ng-container>
    </ng-container>


    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>
<mat-paginator [pageSizeOptions]="paginationValues"
               [hidden]="!tableData?.data.length"></mat-paginator>

<mat-error *ngIf="!tableData?.data.length">No historical prices found</mat-error>
